import { CatalogSession } from '@/Model/sessions/catalogTypes';

/**
 * Checks if the session wait list is enabled.
 * @param {CatalogSession} session - The session to check if the wait list is enabled.
 * @returns {boolean} Returns true if the wait list is enabled, otherwise false.
 */
export function hasWaitlistIsUnlimitedActive(session: CatalogSession): boolean {
  return !!session.waitListIsUnlimited;
}

/**
 * Checks if both the session scholar and wait list capacity are full.
 * @param {CatalogSession} session - The session to check for capacity.
 * @returns {boolean} Returns true if both scholar and wait list capacity are full, otherwise false.
 */
export function hasCapacityFull(session: CatalogSession): boolean {
  return hasScholarCapacityFull(session) && hasWaitListCapacityFull(session);
}

/**
 * Checks if the session scholar capacity is full.
 * @param {CatalogSession} session - The session to check for scholar capacity.
 * @returns {boolean} Returns true if the scholar capacity is full, otherwise false.
 */
export function hasScholarCapacityFull(session: CatalogSession): boolean {
  const { enrollmentCount, scholarCapacity = 0 } = session;
  return enrollmentCount >= scholarCapacity;
}

/**
 * Checks if the session wait list capacity is full.
 * @param {CatalogSession} session - The session to check for wait list capacity.
 * @returns {boolean} Returns true if the scholar capacity is full, otherwise false.
 */
export function hasWaitListCapacityFull(session: CatalogSession): boolean {
  const { waitlistCount, waitlistCapacity = 0 } = session;
  return !hasWaitlistIsUnlimitedActive(session) && waitlistCount >= waitlistCapacity;
}
